module.exports = __webpack_public_path__ + "media/images/lp/lp03-a8f4789bb4fc062efef38154b41a062a.webp";